import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button } from "zina-dogi-react";
import { Row, Col } from "reactstrap";
import PartialCancellationTable from "./partial_cancel_table.component";

class SSOTIModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            comments: [],
            requestData: {},
            withOnSend: false,
            nextStep: null
        };
    }

    close = () => {
        this.setState({
            modal: false
        });
    };

    open = () => {
        this.setState({
            modal: true
        });
    };

    toggle = () => {
        const modal = !this.state.modal;
        if (modal) {
            this.open();
        } else {
            this.close();
        }
    };

    render() {
        const { className, buttonLabel } = this.props;
        const { modal } = this.state;
        const modalStyle = { width: "80%", maxWidth: "80%" };
        return (
            <div>
                {buttonLabel && (
                    <Button color="primary" onClick={this.toggle}>
                        {buttonLabel}
                    </Button>
                )}
                <Modal isOpen={modal} toggle={this.toggle} className={className} backdrop="static" style={modalStyle}>
                    <ModalHeader toggle={this.toggle}>Cancel/Amend SSOTI</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <PartialCancellationTable
                                    getData={this.props.getData}
                                    cancelled={this.props.cancelled}
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this._cancel}>
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
    _cancel = () => {
        this.close();
    };
}

export default SSOTIModal;
